import { api } from '../api'

export const priceListApi = api
  .enhanceEndpoints({
    addTagTypes: ['priceList'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPriceList: builder.query({
        providesTags: ['priceList'],
        query: () => ({
          url: '/pricelist/roles',
          method: 'GET',
        }),
        transformResponse: (response) => response?.data || [],
      }),
      getPriceListHistory: builder.query({
        providesTags: ['priceList'],
        query: (slug) => ({
          url: `/pricelist/history/${slug}`,
          method: 'GET',
        }),
        transformResponse: (response) => response?.data || [],
      }),
    }),
  })

export const { useGetPriceListQuery, useGetPriceListHistoryQuery } =
  priceListApi
